import React from "react";

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';

import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import InputLabel from '@material-ui/core/InputLabel';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Select from '@material-ui/core/Select';
import Slider from '@material-ui/core/Slider';

import SearchHits from './SearchHits'

import { useStyles } from './UserTheme';

import FoldingFrame from "../FoldingFrame/FoldingFrame";

const sector = [
  "Autóipar",
  "Kereskedelem",
  "Szolgáltatóipar",
  "Élelmiszeripar",
  "Vegyipar",
  "Építőipar",
];

const school = [
  "MiniCrm",
  "MomoCrm",
  "Salesautopilot",
  "SAP",
  "EasyOrder",
  "Operel",
  "Monda",
  "ActiveCampaign",
];

const position = [
  'családbarát',
  'magas fizetés',
  'zöld környezet',
  'dinamikus közösség'
];

export default function SearchPage() {
  const classes = useStyles();
  const [sectorName, setSectorName] = React.useState(sector);
  const [personName, setPersonName] = React.useState(school);
  const [positionName, setpositionName] = React.useState(position);

  const [incom, setIncom] = React.useState([20, 37]);

  const handleChangeIncom = (event, newValue) => {
    setIncom(newValue);
  };

  const handleChangeMultipleSector = (event) => {
    const { options } = event.target;
    const value = [];
    for (let i = 0, l = options.length; i < l; i += 1) {
      if (options[i].selected) {
        value.push(options[i].value);
      }
    }
    setSectorName(value);
  };

  const handleChangeMultiple = (event) => {
    const { options } = event.target;
    const value = [];
    for (let i = 0, l = options.length; i < l; i += 1) {
      if (options[i].selected) {
        value.push(options[i].value);
      }
    }
    setPersonName(value);
  };

  const handleChangeMultipleposition = (event) => {
    const { options } = event.target;
    const value = [];
    for (let i = 0, l = options.length; i < l; i += 1) {
      if (options[i].selected) {
        value.push(options[i].value);
      }
    }
    setpositionName(value);
  };


  return <Grid container direction="row" className={classes.root}>
    <FoldingFrame open={true}>
      <Grid item className={classes.formContanier} id="collapseForm">
        <Typography align="center" variant="h6" gutterBottom>
          Cégkeresés
        </Typography>
        <Divider />
        <form className={classes.form} >
          <Typography align="center" variant="h6"></Typography>
          <div>
            <TextField
              id="search-title"
              name='title'
              label="A keresés megnevezése"
              defaultValue=""
              helperText="A keresés azonosítására szolgál"
              variant="outlined"
              size="small"
              type="text"
              fullWidth
            />
          </div>

          <div><Divider component="hr" /></div>

          <div>
            <TextField
              // id="user-middleName"
              label="A cég neve"
              name='middleName'
              defaultValue=""
              helperText=""
              variant="outlined"
              size="small"
              type="text"
              fullWidth
            />
          </div>

          <div>
            <TextField
              // id="search-city"
              name=''
              label="Ország"
              defaultValue=""
              helperText=""
              variant="outlined"
              size="small"
              type="text"
              fullWidth
            />
          </div>

          <div>
            <TextField
              name=''
              label="Megye"
              defaultValue=""
              helperText=""
              variant="outlined"
              size="small"
              type="text"
              fullWidth
            />
          </div>

          <div>
            <TextField
              name='city'
              label="Város"
              defaultValue=""
              helperText=""
              variant="outlined"
              size="small"
              type="text"
              fullWidth
            />
          </div>
          <div>
            <FormControl component="fieldset" className={classes.formControl}>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox />}
                  label="Van meghírdetett állás"
                />
                <FormControlLabel
                  control={<Checkbox />}
                  label="Van továbbtanulási támogatás"
                />
                <FormControlLabel
                  control={<Checkbox />}
                  label="Van a vezetőnek feltöltött CV-je"
                />
                <FormControlLabel
                  control={<Checkbox />}
                  label="Van a vezetőnek személyiség tesztje"
                />
                <FormControlLabel
                  control={<Checkbox />}
                  label="Van ajánlás munkavállalóktól"
                />
                <FormControlLabel
                  control={<Checkbox />}
                  label="Van értékesítési szektor leírása"
                />
                <FormControlLabel
                  control={<Checkbox />}
                  label="Van cégbemutatkozó videója"
                />
              </FormGroup>
            </FormControl>
          </div>

          <div>
            <Typography id="range-slider" gutterBottom>
              Éves árbevétel (millió forint)
            </Typography>
            <Slider
              value={incom}
              onChange={handleChangeIncom}
              valueLabelDisplay="auto"
              aria-labelledby="range-slider"
            />
          </div>

          <div>
            <FormControl fullWidth variant="outlined" className={classes.formControl}>
              <InputLabel style={{ background: '#ddd', }} htmlFor="select-multiple-native">Értékesítési szektor</InputLabel>
              <Select
                multiple
                native
                fullWidth
                value={sectorName}
                onChange={handleChangeMultipleSector}
                inputProps={{
                  id: 'select-multiple-native',
                }}
              >
                {sector.map((name, index) =>
                  <option key={`select1-${index}`} value={name}>
                    {name}
                  </option>
                )}
              </Select>
            </FormControl>
          </div>

          <div>
            <FormControl fullWidth variant="outlined" className={classes.formControl}>
              <InputLabel style={{ background: '#ddd', }} htmlFor="select-multiple-native">Ügyfélkezelési rendszer</InputLabel>
              <Select
                multiple
                native
                fullWidth
                value={personName}
                onChange={handleChangeMultiple}
                inputProps={{
                  id: 'select-multiple-native',
                }}
              >
                {school.map((name, index) =>
                  <option key={`select2-${index}`} value={name}>
                    {name}
                  </option>
                )}
              </Select>
            </FormControl>
          </div>

          <div>
            <FormControl fullWidth variant="outlined" className={classes.formControl}>
              <InputLabel style={{ background: '#ddd', }} htmlFor="select-multiple-native">A cég erősségei</InputLabel>
              <Select
                multiple
                native
                fullWidth
                value={positionName}
                onChange={handleChangeMultipleposition}
                inputProps={{
                  id: 'select-multiple-native',
                }}
              >
                {position.map((name, index) =>
                  <option key={`select3-${index}`} value={name}>
                    {name}
                  </option>
                )}
              </Select>
            </FormControl>
          </div>
          <div className={classes.button}>
            <Button
              variant="contained"
              color="primary"
              fullWidth
            >
              Keresés indítása
            </Button>
          </div>
        </form>
      </Grid>
    </FoldingFrame>
    <Grid item xs>
      <Grid container className={classes.grund}>
        <SearchHits />
      </Grid>
    </Grid>
  </Grid >;
}